import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/core/hooks/windowSize.js",
  _this = this;
import React, { useEffect, useState } from 'react';
import getComponentName from '../../helpers/getComponentName';
import debounce from '../utils/debounce';
/**
 *
 * @param debounceDuration
 * @return {{width: number, height: number}}
 */

export function useWindowSize() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$debounceDuration = _ref.debounceDuration,
    debounceDuration = _ref$debounceDuration === void 0 ? 0 : _ref$debounceDuration;
  var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }
  var _useState = useState(getSize),
    _useState2 = _slicedToArray(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  var updateWindowSize = setWindowSize;
  if (debounceDuration) {
    updateWindowSize = debounce(setWindowSize, debounceDuration);
  }
  useEffect(function () {
    if (!isClient) {
      return false;
    }
    function handleResize() {
      updateWindowSize(getSize());
    }
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return windowSize;
}
export var withWindowSize = function withWindowSize(Component, options) {
  var WithWindowSize = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var windowSize = useWindowSize(options);
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      ref: ref,
      windowSize: windowSize,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 12
      }
    }));
  });
  WithWindowSize.displayName = "WithWindowSize".concat(getComponentName(Component));
  return WithWindowSize;
};